const PRICE_FORMAT = /\B(?=(\d{3})+(?!\d))/g;
const PRICE_PARSER = /[^0-9.-]/g;
const EMAIL_REGEX = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;

export default {
  PRICE_FORMAT,
  PRICE_PARSER,
  EMAIL_REGEX,
};
